<div #container class="nc-letter-glitch-container">
  <canvas #canvas class="nc-letter-glitch-canvas"></canvas>
  <div *ngIf="ncOuterVignette" class="nc-outer-vignette"></div>
  <div *ngIf="ncCenterVignette" class="nc-center-vignette"></div>
</div>
<div class="nc-content-wrapper">
    <ng-content></ng-content>
</div>
